export const notices = {
    additions: ['Дополнительные', 'Additions'],
    airportNotFind: ['Аэропорт с кодом ICAO {{code}} не найден', 'Airport with ICAO code {{code}} was not find.'],
    altDeparture: ['Запасные по вылету', 'Alternates departure'],
    altLanding: ['Запасные по прилету', 'Alternates arrival'],
    departure: ['Вылет', 'Departure'],
    enroute: ['По трассе', 'En-Route'],
    failGetNotice: [
        'Не удалось загрузить НОТАМы с сервера. Пожалуйста, попробуйте позже!',
        'Failed to get NOTAMs from the server. Please try again later!',
    ],
    fir: ['FIR', 'FIR'],
    landing: ['Прилет', 'Landing'],
};
